import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg`
  fill: ${({ theme }) => theme.colors.brand03};
  &.teal {
    fill: ${({ theme }) => theme.colors.brand03};
  }
`;

export const CheckIcon = (props) => (
  <SVG {...props} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM8 15l-5-5 1.41-1.41L8 12.17l7.59-7.59L17 6l-9 9z" />
  </SVG>
);

export default CheckIcon;
